<template>
  <v-container grid-list-lg wrap class="authors-list">
    <p class="title">Autores</p>
    <v-layout align-start justify-center px-5 pb-5 wrap>
      <Lister :items="authors" :hideSearchbar="true" :cardBreakpoints="'xs12 md6'">
        <template v-slot:default="slotProps">
          <AuthorContent :author="slotProps.item"></AuthorContent>
        </template>
      </Lister>
    </v-layout>
  </v-container>
</template>

<script>
import Lister from '@/components/Lister.vue';
import AuthorContent from './AuthorContent.vue';

export default {
  components: { AuthorContent, Lister },
  props: {
    authors: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style scoped>
  .authors-list{
    padding-top: 20px;
    margin-left: -11px;
  }
  .title{
    color: black;
    text-align: left;
  }
</style>
